module.exports = __webpack_public_path__ + "static/media/widgets.2c6934e8.svg";